import { render, staticRenderFns } from "./CPGiftCardSettings.vue?vue&type=template&id=1d3ebd42&scoped=true&"
import script from "./CPGiftCardSettings.vue?vue&type=script&lang=js&"
export * from "./CPGiftCardSettings.vue?vue&type=script&lang=js&"
import style0 from "./CPGiftCardSettings.vue?vue&type=style&index=0&id=1d3ebd42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3ebd42",
  null
  
)

export default component.exports